import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Grid,
  Typography,
  Button
} from '@material-ui/core'

function TemplateSellFinalPopup({ isOpen, callback }) {
  const { t } = useTranslation()
  return (
    <Dialog open={isOpen} onClose={callback}>
      <DialogContent className="viewDialog-inner">
        <div className="publishSmallBlock">
          <div className="viewDialog-inner__header">
            <DialogTitle className="viewDialog-inner__title">{t('youreAllSet')}</DialogTitle>
            <DialogContentText className="viewDialog-inner__subtitle">{t('yourTemplateDashboard')}</DialogContentText>
          </div>
          <div className="mainPublishImage">
            <img src="https://b24chat.com/uploads/cloud/260/barel@purpleux.com/Canvas/All%20designs/139.png" />
            <Typography>12$</Typography>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="viewDialog-footer">
        <Button onClick={callback}>{t('finish')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default TemplateSellFinalPopup
